import { Store } from 'vuex'
import { createTitleLabel } from '@/domain/item/ItemListView/titleLabel'
import { getItemListViewCollection } from '@/domain/item/ItemListView/collectionLabel'
import { getItemListViewContent, getItemListViewSpot } from '@/domain/item/ItemListView/contentLabel'

export const useItemListViewText = (item: any, store: Store<any>, lang: string) => {
  return {
    itemListViewContent: getItemListViewContent(item, store, lang),
    itemListViewCollection: getItemListViewCollection(item, store, lang),
    itemListViewTitle: createTitleLabel(item),
    itemListViewSpot: getItemListViewSpot(item)
  }
}
